export default __webpack_public_path__ + "static/media/3-Commerce.120e8834.png";